import {
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  Divider,
  makeStyles,
  Button,
  Grid,
} from '@material-ui/core'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import React, { useContext, useState } from 'react'
import Linkify from 'react-linkify'
import { useDispatch } from 'react-redux'
import { EditCommentForm } from '..'
import { openSnackbar } from '../../ducks/snackbar/actions'
import { IComment } from 'daily-dose-common'
import { firestore } from '../../firebase-init';
import { useDialog } from '../../providers/dialog-provider'
import { FirestoreContext } from '../../providers/firestore-provider'
import { Like } from '../like'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  },
  editButton: {
    textTransform: 'none',
    padding: 0,
    minWidth: '20px',
    display: 'flex',
  },
}))

interface ICommentItemProps {
  commentItem: IComment
}

const CommentItem = ({ commentItem }: ICommentItemProps) => {
  dayjs.extend(relativeTime)
  const classes = useStyles()
  const dispatch = useDispatch()
  const { currentUser } = useContext(FirestoreContext)
  const { openDialog, closeDialog } = useDialog()
  const [comment, setComment] = useState<IComment>(() => commentItem)
  const commentRef = firestore
    .collection('circles')
    .doc(comment.circleId)
    .collection('doses')
    .doc(comment.doseId)
    .collection('comments')
    .doc(comment.id as string) // TODO: Fix id part firestore.types

  if (!comment.user) return null
  if (!comment.content) return null

  const onEditComment = () => {
    openDialog({
      color: 'primary',
      title: 'Add group',
      confirmText: 'Submit',
      custom: true,
      description: (
        <EditCommentForm
          comment={commentItem}
          onUpdateComment={(c: IComment) => {
            setComment(c)
            closeDialog()
            dispatch(openSnackbar(`Your comment was updated`, 'success'))
          }}
          onCancelComment={() => closeDialog()}
        />
      ),
      fullScreen: true,
    })
  }

  const commentBelongsToUser = (comment: IComment) =>
    currentUser?.id === comment.userId

  const displayTime = ` — ${dayjs(comment.createdAt.toDate()).fromNow()}`

  const hasUserPicture =
    (commentBelongsToUser(comment) && currentUser?.photoURL) || comment.user.photoURL

  return (
    <List className={classes.root}>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          {hasUserPicture ? (
            <Avatar alt={comment.user.displayName} src={hasUserPicture} />
          ) : (
            <Avatar alt={comment.user.displayName}>
              {currentUser?.displayName?.charAt(0)?.toUpperCase()}
            </Avatar>
          )}
        </ListItemAvatar>
        <ListItemText
          className="dont-break-out"
          primary={
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              <Typography
                component="span"
                variant="body2"
                className={classes.inline}
                color="textPrimary"
              >
                {(commentBelongsToUser(comment) && currentUser?.displayName) ||
                  comment.user.displayName}
              </Typography>
              {currentUser?.id === comment.userId && (
                <Button
                  color="primary"
                  onClick={onEditComment}
                  size="small"
                  className={classes.editButton}
                >
                  Edit
                </Button>
              )}
            </Grid>
          }
          secondary={
            <React.Fragment>
              <Linkify>{comment.content}</Linkify>
              <Typography component="span" variant="body2" color="textSecondary">
                {displayTime}
              </Typography>
              <Like docRef={commentRef} likeCount={comment.likeCount} size="small" />
            </React.Fragment>
          }
        />
      </ListItem>
      <Divider variant="inset" component="li" />
    </List>
  )
}

export default CommentItem
